import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
.module('bringoz.admin.oms')
.factory('$omsOrder', omsObjectFactory);

/* @ngInject */
function omsObjectFactory($bringozFactory: $bringozFactory,
                          OmsOrderAPI: BringozApi,
                          OmsOrders_DS: DataStoreConfig,
                          OmsOrders_PN: PushNotificationsConfig) {

  function $omsOrder(id: string) {
    return $bringozFactory(id, OmsOrderAPI, OmsOrders_DS, OmsOrders_PN)
  }

  return $omsOrder;
}
